{
  "helpMessage": "<h3>有疑问吗？</h3>\n<p>我们乐意为您提供帮助 - 请致电我们的团队：<br/>\n<a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>选项 2</strong>）<br/>\n周一至周五，上午 8 点至下午 5 点。</p>",
  "text": "<p>我们会通知您的转诊医生，他们可能会联系您讨论下一步。</p>\n<p>目前您无需做任何其他事情。</p>",
  "title": "您已选择暂时不预约。"
}
